import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'messagebox-app',
      templateUrl: './messagebox.component.html',
      styleUrls: ['messagebox.component.css']
    })

export class MessageBoxComponent {
  @Input() message_text;
  @Input() message_mode;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ret:any={
    status:"",
    template_name:""
  }

  modalCloseOK() {
      this.ret.status = 'OK';
      this.activeModal.close(this.ret);
  }
  modalCloseCancel(){
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/c9902-messagebox/messagebox.component.ts